import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import SiteSearch from "./SiteSearch";

const navItems = [
  { label: "首页", to: "/" },
  { label: "剧情", to: "/category/episodes" },
  { label: "角色", to: "/category/characters" },
  { label: "资讯", to: "/category/news" },
  { label: "关于", to: "/about" },
];

export default function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const transparent = isHome && !scrolled && !menuOpen;

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
          transparent
            ? "bg-transparent"
            : "bg-background-50/95 backdrop-blur border-b border-background-200"
        }`}
      >
        <div className="px-4 md:px-8 h-16 md:h-20 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2.5 cursor-pointer shrink-0">
            <span className="w-9 h-9 rounded-md bg-primary-600 flex items-center justify-center">
              <i className="ri-vidicon-2-line text-accent-400 text-lg" />
            </span>
            <span
              className={`font-heading font-semibold text-base md:text-lg tracking-wide ${
                transparent ? "text-background-50" : "text-foreground-900"
              }`}
            >
              继母的诱惑
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `px-4 py-2 text-sm rounded-md cursor-pointer transition-colors ${
                    isActive
                      ? transparent
                        ? "text-accent-300 font-medium"
                        : "text-primary-600 font-medium"
                      : transparent
                        ? "text-background-100 hover:text-accent-200"
                        : "text-foreground-700 hover:text-primary-600"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => setSearchOpen(true)}
              aria-label="全站搜索"
              className={`hidden sm:flex items-center gap-2 pl-3 pr-4 h-9 rounded-md text-sm cursor-pointer border transition-colors ${
                transparent
                  ? "border-background-100/40 text-background-100 hover:border-accent-300"
                  : "border-background-300 text-foreground-600 hover:border-primary-400"
              }`}
            >
              <i className="ri-search-line text-base" />
              <span>搜索</span>
            </button>
            <button
              type="button"
              onClick={() => setSearchOpen(true)}
              aria-label="全站搜索"
              className={`sm:hidden w-9 h-9 flex items-center justify-center rounded-md cursor-pointer ${
                transparent ? "text-background-50" : "text-foreground-700"
              }`}
            >
              <i className="ri-search-line text-lg" />
            </button>
            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              aria-label="菜单"
              className={`md:hidden w-9 h-9 flex items-center justify-center rounded-md cursor-pointer ${
                transparent ? "text-background-50" : "text-foreground-700"
              }`}
            >
              <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-xl`} />
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200">
            <nav className="px-4 py-3 flex flex-col">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === "/"}
                  className={({ isActive }) =>
                    `px-3 py-3 rounded-md text-sm cursor-pointer ${
                      isActive
                        ? "text-primary-600 font-medium bg-primary-50"
                        : "text-foreground-700 hover:bg-background-100"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>
        )}
      </header>

      <SiteSearch open={searchOpen} onClose={() => setSearchOpen(false)} />
    </>
  );
}